module.exports = __webpack_public_path__ + "img/app_passes_screen@2x.41765756.png";